import React, { useCallback, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Tab, Tabs, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RelatedMotion from './RelatedMotion';
import PersuasiveMotion from './PersuasiveMotion';
import SignificantMotion from './SignificantMotion';
import EditorialChangeSection from '../EditorialChangeSection';
import TechnicalChangeMotion from './TechnicalChangeMotion';
import IncorporateTechnicalChangeMotion from './IncorporateTechnicalChangeMotion';
import CustomMotion from './CustomMotion';

import commonStyles from 'styles/common.module.scss';

enum ReviewAction {
  Related = 'Related',
  Persuasive = 'Persuasive',
  NotSignificant = 'NotSignificant',
  EditorialChanges = 'EditorialChanges',
  CustomMotion = 'CustomMotion',
}

const ReviewActions: React.FunctionComponent = () => {
  const [activeTab, setActiveTab] = useState<string>(ReviewAction.Related);

  const handleTabChange = useCallback((_: any, value = ReviewAction.Related) => {
    setActiveTab(value);
  }, []);

  return (
    <TabContext value={activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor={'primary'}
          textColor={'primary'}
          variant={'scrollable'}
        >
          <Tab value={ReviewAction.Related} label={'Related'} className={commonStyles.tab} />
          <Tab value={ReviewAction.Persuasive} label={'Persuasive'} className={commonStyles.tab} />
          <Tab value={ReviewAction.NotSignificant} label={'Not Significant'} className={commonStyles.tab} />
          <Tab value={ReviewAction.EditorialChanges} label={'Editorial Changes'} className={commonStyles.tab} />
          <Tab value={ReviewAction.CustomMotion} label={'Custom Motion'} className={commonStyles.tab} />
        </Tabs>
      </Box>
      <TabPanel className={commonStyles.tabPanel} value={ReviewAction.Related}>
        <RelatedMotion />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={ReviewAction.Persuasive}>
        <PersuasiveMotion />
        <Accordion sx={{ mt: 3 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle2">Technical Change</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TechnicalChangeMotion />
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle2">Incorporate Technical Change</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <IncorporateTechnicalChangeMotion />
          </AccordionDetails>
        </Accordion>
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={ReviewAction.NotSignificant}>
        <SignificantMotion />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={ReviewAction.EditorialChanges}>
        <EditorialChangeSection />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={ReviewAction.CustomMotion}>
        <CustomMotion />
      </TabPanel>
    </TabContext>
  );
};

export default ReviewActions;
